import { render, staticRenderFns } from "./EpoXmlForm.vue?vue&type=template&id=4c704c06&"
import script from "./EpoXmlForm.vue?vue&type=script&lang=js&"
export * from "./EpoXmlForm.vue?vue&type=script&lang=js&"
import style0 from "./EpoXmlForm.vue?vue&type=style&index=0&id=4c704c06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports